<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-4"><a href="#/Ruddy_Gore2#Contents-A">Dedication</a></p>
<p class="Body-Center para-style-override-3"><span class="Italic">To my sister Janet Greenwood,<br/>for her courage and her delightful spirit.</span></p>
<p class="Body-Center para-style-override-3"><span class="Italic"> </span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ruddy_Gore-3.vue?65c76292